<template>
    <div>
        <div class="box box--white ssv-course-header">
            <div class="ssv-course-header__name">
                <h3>Knižní verze VKS až na vaši adresu</h3>
                <div v-html="course.content"/>
            </div>
            <div class="ssv-course-header__price">
                <div class="ssv-course-header__price-value">
                    {{course.priceVat}} Kč<br>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name:     'SsvOrderHeaderVks',
        computed: {
            ...mapGetters('ssvOrder', ['course']),
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/header/HeaderVks.vue